(function () {
    'use strict';
    angular
        .module('recomActionPlanUpdateStatusControllers')
        .controller('ActionPlanUpdateStatusValidateController', Controller);
    Controller.$inject = ['$rootScope', '$scope', '$state', 'historyCtxtService'];

    function Controller($rootScope, $scope, $state, historyCtxtService) {
    }

})();